import { render, staticRenderFns } from "./ZastosowaniaSheet.vue?vue&type=template&id=037b4f58&"
import script from "./ZastosowaniaSheet.vue?vue&type=script&lang=ts&"
export * from "./ZastosowaniaSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports